[
  require.context('.', true, /\.spec\.js$/),
].forEach((req) => {
  req.keys().forEach((key) => {
    req(key);
  });
});



// WEBPACK FOOTER //
// ./src/3rdparty/walkontable/test/spec/index.js